import { Avatar, Group, Text, UnstyledButton } from "@mantine/core";
import { Link } from "react-router-dom";
import classes from "./UserMenu.module.css";

export function UserMenu({ user }) {
  const fullName = `${user?.firstName} ${user?.lastName}`;

  return (
    <UnstyledButton className={classes.user} component={Link} to="/app/profile">
      <Group gap={7}>
        {user?.picture ? (
          <Avatar src={user.picture} radius="xl" size={30} />
        ) : (
          <Avatar radius="xl" color="blue" size={30}>
            {user?.firstName?.[0]}
            {user?.lastName?.[0]}
          </Avatar>
        )}
        <div className={classes.userInfo}>
          <Text className={classes.userName}>{fullName}</Text>
        </div>
      </Group>
    </UnstyledButton>
  );
}
